import autobind from 'core-decorators/lib/autobind';

import { WixConnect } from 'shared/utils/wix-connect';

import { isPreviewMode, openPreviewPrompt } from 'widget/components/preview-prompt/preview-prompt';

import {
  openFullScreenSubscribeOverlay,
  openFullScreenPurchaseOverlay,
} from 'shared/utils/open-overlay';


// TODO move openPurchase openSubscription to view and use Player instead
// in the future, all functions like this will be combined to HOCs and will be used as wrappers at views
const extendWithFullScreenBuy = PlayerComponent => {

  @WixConnect()
  class FullScreenBuyExtensions extends React.Component {

    static propTypes = {
      canShowChannelCover: React.PropTypes.bool,
      onMemberSignUp: React.PropTypes.func,
      isUserLogged: React.PropTypes.bool,
      memberOnlyOverlay: React.PropTypes.any,
      videoItem: React.PropTypes.object,
      channelData: React.PropTypes.object,

      biEvent: React.PropTypes.func,
    };

    @autobind
    openPurchase() {
      if (isPreviewMode()) {
        openPreviewPrompt();
        return;
      }

      const { videoItem, channelData } = this.props;
      openFullScreenPurchaseOverlay(channelData.id, videoItem.id);
    }

    @autobind
    openSubscription() {
      if (isPreviewMode()) {
        openPreviewPrompt();
        return;
      }

      const { channelData } = this.props;

      openFullScreenSubscribeOverlay(channelData.id, () => {
        this.props.biEvent('widget.subscriptionPopUp.Completed', { result: 'canceled', errorMsg: '' });
      });
    }

    render() {

      const props = _.omit(this.props,
        'onPurchaseClick',
        'onSubscribeClick'
      );

      return (
        <PlayerComponent {...props}
                         onPurchaseClick={this.openPurchase}
                         onSubscribeClick={this.openSubscription} />
      );
    }

  }

  return FullScreenBuyExtensions;
};


export default extendWithFullScreenBuy;



// WEBPACK FOOTER //
// ./src/widget/views/desktop/strip/player/fs-buy-extensions.js